import { render, staticRenderFns } from "./SigninPage.vue?vue&type=template&id=33cce7c0&scoped=true"
import script from "./SigninPage.vue?vue&type=script&lang=js"
export * from "./SigninPage.vue?vue&type=script&lang=js"
import style0 from "./SigninPage.vue?vue&type=style&index=0&id=33cce7c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33cce7c0",
  null
  
)

export default component.exports